/**
 * FAQ page: turn each category section (a heading text block + an accordion)
 * into a collapsible level-1 row, per the Figma design (node 11586:16345).
 *
 * The FAQ content lives in templates/page.faq.json, which is admin-owned and never
 * pushed from this repo, so the two-level structure is built here at runtime instead.
 * Without JS every category stays open — the content is still fully readable.
 */
(() => {
  const init = () => {
    const main = document.querySelector('main[data-template="page.faq"]');
    if (!main) return;

    const groups = [];

    const setOpen = (group, open) => {
      const toggle = group.querySelector('.faq-category__toggle');
      const panel = group.querySelector('.accordion');
      toggle.setAttribute('aria-expanded', String(open));
      group.classList.toggle('is-open', open);
      panel.hidden = !open;
    };

    main.querySelectorAll('.section-content-wrapper').forEach((group) => {
      const heading = group.querySelector('.text-block :is(h2, h3, h4, h5, h6)');
      const panel = group.querySelector('.accordion');
      if (!heading || !panel || heading.querySelector('.faq-category__toggle')) return;

      const index = groups.length;
      const id = `faq-category-panel-${index}`;
      panel.id = id;
      panel.hidden = true;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'faq-category__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', id);
      toggle.textContent = heading.textContent.trim();
      heading.replaceChildren(toggle);

      group.classList.add('faq-category');
      if (index === 0) group.classList.add('faq-category--first');

      /* One category open at a time; the first is open on load. */
      toggle.addEventListener('click', () => {
        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        groups.forEach((other) => setOpen(other, other === group && willOpen));
      });

      groups.push(group);
    });

    if (!groups.length) return;
    setOpen(groups[0], true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
